import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Turnstile } from "@marsidev/react-turnstile";
import { firebaseAuth } from "../firebase";
import logo from "../assets/logo.webp";
import "../styles/Login.css";

const TURNSTILE_SITE_KEY = "0x4AAAAAACohYrDRnmpigBMD";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setErrorMessage("");

    if (!email || !password) {
      setErrorMessage("❌ يرجى إدخال البريد الإلكتروني وكلمة المرور.");
      return;
    }

    if (!turnstileToken) {
      setErrorMessage("❌ يرجى إكمال التحقق الأمني أولاً.");
      return;
    }

    setIsLoading(true);
    try {
      await firebaseAuth.signIn(email, password);

      // ✅ Force reload to let App.js checkAuth re-run and sync user status correctly
      window.location.href = "/dashboard";
    } catch (error) {
      console.error("Login catch:", error);
      let msg = "❌ خطأ في تسجيل الدخول";
      if (error.code === 'auth/invalid-credential' || error.message.includes('INVALID_LOGIN_CREDENTIALS')) {
        msg = "بيانات الدخول غير صحيحة";
      }
      setErrorMessage(msg);
      setIsLoading(false);
      setTurnstileToken(null); // ✅ إعادة تعيين التحقق عند الفشل
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="لوغو دارس" className="auth-logo" style={{ width: "150px", marginBottom: "20px", display: "block", marginLeft: "auto", marginRight: "auto" }} />
      <h2 style={{ textAlign: "center" }}>🔐 تسجيل الدخول</h2>
      <input
        type="email"
        placeholder="📧 البريد الإلكتروني"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={isLoading}
      />
      <input
        type="password"
        placeholder="🔑 كلمة المرور"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        disabled={isLoading}
      />

      {/* ✅ Cloudflare Turnstile - التحقق من البشر */}
      <div style={{ margin: "12px 0", display: "flex", justifyContent: "center" }}>
        <Turnstile
          siteKey={TURNSTILE_SITE_KEY}
          onSuccess={(token) => {
            setTurnstileToken(token);
            setErrorMessage("");
          }}
          onExpire={() => setTurnstileToken(null)}
          onError={() => setErrorMessage("❌ خطأ في التحقق الأمني، حاول مجدداً.")}
          options={{ language: "ar", theme: "auto" }}
        />
      </div>

      {errorMessage && <p className="error-message">{errorMessage}</p>}

      <button onClick={handleLogin} disabled={isLoading}>
        {isLoading ? "⏳ جارٍ تسجيل الدخول..." : "🚀 تسجيل الدخول"}
      </button>

      {/* ✅ رابط نسيان كلمة المرور */}
      <button
        className="forgot-link"
        onClick={() => navigate("/forgot-password")}
        disabled={isLoading}
        style={{
          background: "none",
          border: "none",
          color: "#6c63ff",
          fontSize: "13px",
          fontFamily: "'Cairo', sans-serif",
          cursor: "pointer",
          margin: "4px 0 8px",
          textDecoration: "underline",
          width: "100%",
          textAlign: "center",
        }}
      >
        🔑 نسيت كلمة المرور؟
      </button>

      {/* ✅ زر الانتقال إلى صفحة التسجيل */}
      <button className="register-button" onClick={() => navigate("/register")} disabled={isLoading}>
        ✍️ إنشاء حساب جديد
      </button>
    </div>
  );
};

export default Login;
